import { Button, Col, Divider, Image, Row, Tabs, Tooltip, Space, Layout, Table, message, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { colorDate, extractValueFromUrl, getItemAlt, getListPrice, imageFallback, parseAuthors, parseSubjects, parseSubjectsList } from "../utils/Utils";
import conditional from "../utils/conditional";
import SalesIndicator from "./SalesIndicator";
import moment from "moment-timezone";
import { useHistory, useLocation, useParams } from "react-router";
import Html from "../utils/Html";
import { useSession } from "../utils/Session";
import { Link } from "react-router-dom";
import { apiCall } from "../utils/Api";
import TitleRank from "./TitleRank";
import Pubstock from "./Pubstock";
import Peers from "./Peers";
import TitleImage from "./TitleImage";
import ListCount from "./ListCount";
import CatalogueCount from "./CatalogueCount";
import DigitalResources from "./DigitalResources";
import ListQuickPick from "./ListQuickPick";
import CopyButton from "../util_components/CopyButton";
import { CopyFilled, CloseOutlined } from '@ant-design/icons'
import TitleExtras from "./TitleExtras";
import Renderer from "./Renderer";
import Related from "./TitleRelated";
import Comparables from "./TitleRelated";
import TitleRelated from "./TitleRelated";

export function TitleTable(props) {


    const [expanded, setExpanded] = useState([]);

    const expandCell = (_data, _type) => {
        if (!expanded.includes(_data.eisbn)) {
            setExpanded([_data.eisbn]);
        } else {
            setExpanded([]);
        }
    }



    const drawChildTable = (_record) => {

        return (
            <>
                <div className="hideHover" style={{ "marginTop": "-7px", "marginLeft": "-8px", "marginRight": "-8px", "maxWidth": "1210px" }}>
                    <div style={{ "padding": "0 0px" }}>
                        <div style={{ "marginTop": "0px", "borderTop": "none", "backgroundColor": "#f1f1f1" }} className="closebar">
                            <Button style={{ "float": "right" }} onClick={() => setExpanded([])} size="small" type="text" icon={<small><CloseOutlined style={{ "fontSize": "10px", "color": "#111" }} /></small>} />
                            <br clear="both" />
                        </div>
                    </div>
                    <div style={{ "padding": "10px 0px", "backgroundColor": "#fff" }}>
                        <Renderer record_key={expanded} >
                            {(expanded && <Title divider={false} view={"details"} data={_record} />)}
                        </Renderer>
                    </div>
                </div>
            </>
        )
    }

    const { rows = [] } = props;

    const columns = [

        // {
        //     title: <div style={{ "paddingLeft": "2px" }}><small>ISBN</small></div>, dataIndex: 'isbn', key: 'isbn', render: (e) => {
        //         return (<div style={{ "width": "93px", "textAlign": "center", "paddingLeft": "2px" }} className='overhide'><nobr>{e}</nobr></div>)
        //     }
        // },
        {
            title: <small>Title</small>, dataIndex: 'title', key: 'title', render: (e, f) => {
                return <div className='overhide' style={{ "minWidth": "190px" }} ><a onClick={() => expandCell(f)} style={{ "cursor": "pointer" }}>{e}<div style={{ "opacity": "0.7", "fontSize": "12px" }}>{(f.subtitle) ? f.subtitle : ""}</div></a></div>
            }
        },
        {
            title: <small>Author</small>, style: { "overflow": "hidden" }, dataIndex: 'authors', key: 'authors', render: (e) => {
                return <div className='overhide'>{e.map(item => item.name).join(", ")}</div>
            }
        },
        {
            title: <small>Bd</small>, dataIndex: 'binding_code', key: 'binding_code', render: (e) => {
                return <div className='overhide'>{e}</div>
            }
        },
        {
            title: <small>Price</small>, width: "100px", dataIndex: 'price', key: 'price', render: (e, f) => {


                return getListPrice(f.list_price_can, f.list_price_usa, window.sitesettings.is_canadian, true);
            }
        },
        {
            title: <small>PubDate</small>, dataIndex: 'release_date', key: 'release_date', render: (e, f) => {
                return <div className='overhide'><span style={{ whiteSpace: 'nowrap' }} className={colorDate(e, f)}>{moment(e * 1000).format("MMMD-YY")}</span></div>;
            }
        },
        {
            title: <small>Series</small>, dataIndex: 'series', key: 'series', render: (e) => {
                return (<div>{e}</div>)
            }
        },
        {
            title: <small>#</small>, dataIndex: 'series_num', key: 'series_num', render: (e) => {
                return (<div className='overhide'>{e}</div>)
            }
        },
        {
            title: <small>Subjects</small>, dataIndex: 'subjects', key: 'subjects', render: (e) => {
                return (
                    <div className='overhide'>
                        <span>
                            {parseSubjectsList(e, 15)}
                        </span>
                    </div>
                );
            }
        },
        {
            title: <small>Publisher</small>, dataIndex: 'publisher', key: 'publisher', render: (e) => {
                return (<div className='overhide'>{e}</div>)
            }
        },

        {
            title: <small>Rank</small>, dataIndex: 'rank', key: 'rank', render: (e, f) => {
                return (<div style={{ "textAlign": "center" }} className='overhide'><TitleRank highlight={f.highlight} number_only rank={e} /></div>);
            }
        }

    ]

    return (
        <div>
            <div style={{ minWidth: 'auto' }}>
                <Table
                    size="small"
                    pagination={false}
                    columns={columns}
                    rowKey={"eisbn"}
                    className="fullTable"
                    dataSource={rows}
                    expandable
                    expandedRowKeys={expanded}
                    expandIconColumnIndex={-1}
                    onExpand={(e) => { return false; }}
                    expandIcon={() => { return (<></>) }}
                    expandedRowRender={((record) => drawChildTable(record))}
                />
            </div>
        </div>
    )
}

export default function Title(props) {

    const { view = "", divider = true, load_id = "" } = props;
    const [session, setSession] = useSession();
    const history = useHistory();
    const loc = useLocation();
    const [loading, setLoading] = useState(false);
    const { item_id = "" } = useParams();
    const [data, setData] = useState((props?.data) ? props.data : (loc?.state) ? loc.state : {});


    const list_id = (props.list_id) ? props.list_id : extractValueFromUrl(window.location.pathname, "list");


    const {
        reviews = [],
        comments = [],
        rank = [],
        subjects = [],
        bio = [],
        authors = [],
        title = "",
        subtitle = "",
        language = "",
        description = "...",
        publisher = "",
        edition = "",
        eisbn = "",
        cover_image_cache = "",
        pubstock = null,
        isbn = "",
        titlelist_id = "",
        isbn_type = "",
        upc = "",
        upc_type = "",
        series = "",
        series_num = "",
        binding = "",
        pages = "",
        width = "",
        height = "",
        weight = "",
        carton_qty = "",
        media = [{ data: [], type: "" }],
        release_date = null,
        is_forthcoming = false,
        has_libro_audiobook = false,
        list_previous_eisbn = "",
        list_next_eisbn = "",
        audience = "",
        interior_objects = [],
        is_giftcard = false,
        cover_image_key = "",
        has_interiors = null,
        last_order = {
            bookorder_id: null,
            date_ordered: null
        },
        catalogue_count = 0,
        my_lists = [],
        digital_resources = [],
        related_count = {},
        peer_sales = false,

    } = data;


    const [myLists, setMyLists] = useState(my_lists);


    const drawNext = () => {
        if (list_next_eisbn) {
            let url = "/item/" + list_next_eisbn + "/list/" + list_id;
            return (<Button onClick={() => history.push(url)}>Next</Button>)
        } else {
            return (<></>);
        }
    }

    const drawPrev = () => {
        if (list_previous_eisbn) {
            let url = "/item/" + list_previous_eisbn + "/list/" + list_id;
            return (<Button onClick={() => history.push(url)}>Previous</Button>)
        } else {
            return (<></>);
        }
    }


    const getItem = () => {
        if (!item_id && !load_id) { return; }

        let _obj = {}
        _obj.eisbn = (item_id) ? item_id : load_id
        if (list_id) {
            _obj.list_id = list_id;
        }

        setLoading(true);
        apiCall("title/getItem", _obj, (_s, _r) => {

            if (_s) {
                setData(_r);
            } else {
                message.error(_r.error)
            }
            setLoading(false)
        })
    }

    useEffect(getItem, [load_id, history.location.pathname]);


    const wrapPublishDate = (_date) => {


        if (data.is_forthcoming) {
            return (<span style={{ "color": "#BD5800" }}>Releases: {moment(data.release_date * 1000).format('MMM DD, YYYY')}</span>)
        } else {
            return (<span>Published: {moment(data.release_date * 1000).format('MMM DD, YYYY')}</span>)
        }
    }

   



    const linkOut = () => {
        if (list_id) {
            history.push("/item/" + eisbn + "/list/" + list_id)
        } else {
            history.push("/item/" + eisbn)
        }
    }


    const drawSummary = () => {


        const pagesValue = pages != null ? pages + " pages | " : null;
        const widthValue = width && height != null ? width + "\" x " : null;
        const heightValue = width && height != null ? height + "\" | " : null;
        const weightValue = weight != null ? weight + "lbs | " : null;
        const cartonValue = carton_qty != null ? "Crtn: " + carton_qty : null;


        return (
            <Spin spinning={loading}>
                <div className="summary">
                    <div className="title-wrap">
                        <Row gutter={15} style={{ "width": "100%" }} >
                            <Col xs={7} lg={(view === "full") ? 9 : 9} >
                                <TitleImage
                                    cover_image_cache={cover_image_cache}
                                    interior_objects={interior_objects}
                                    isbn={isbn}
                                    cover_image_key={cover_image_key}
                                    eisbn={eisbn}
                                    has_interiors={has_interiors}
                                />
                                <div className="shim" /><div className="shim" />
                                <CopyButton buttonProps={{ "size": "small" }} copy_text={isbn} success_text={<small>Copied!</small>} label={<small><CopyFilled /> {isbn}</small>} />
                            </Col>
                            <Col xs={17} lg={15} >
                                <div>
                                    <div onClick={() => linkOut()} className={(view === "full") ? "summary-title-full" : "summary-title"}>
                                        <a>{title}</a>
                                        <span>{subtitle}</span>
                                    </div>
                                    <div className="shim" />
                                    <conditional.true value={authors.length > 0}>
                                        <span style={{ "display": "block", "lineHeight": "1.2em" }}>by {parseAuthors(data.authors)}<br /></span>
                                    </conditional.true>
                                    <span>{(data.is_large_print) ? "Large Print " : ""}{data.binding}</span>
                                    {getListPrice(data.list_price_can, data.list_price_usa, true, false, 600)}
                                    <conditional.true value={series}>
                                        <div><strong>Series: </strong> {series} {(series_num) ? "#" + series_num : ""}</div>
                                    </conditional.true>
                                    <conditional.true value={language}>
                                        <div><strong>Language:</strong> {language}</div>
                                    </conditional.true>
                                    <div className="shim" />
                                    {parseSubjects(subjects)}
                                    {(data.edition && <div style={{ "fontSize": "12px", "display": "block", "fontWeight": "normal", "marginLeft": "-2px" }}><mark>{data.edition}</mark><div className="shim" /></div>)}

                                    <span style={{ "display": "block", "lineHeight": "16px" }}>
                                        {(data.release_date && wrapPublishDate(data.release_date))}
                                    </span>

                                    <conditional.true value={(!window.sitesettings.hide_sales_rank)}>
                                        <Tooltip mouseEnterDelay={0.5} title={"Based on weekly sales from independent bookstores across the country"}>
                                            <span><TitleRank highlight={false} rank={rank} /></span>
                                        </Tooltip>
                                    </conditional.true>

                                    <span
                                        className="c2"
                                        style={{ "fontSize": "12px", "display": "block", "fontWeight": "normal" }}>
                                        {pagesValue} {widthValue} {heightValue} {weightValue} {cartonValue}
                                    </span>

                                    <div className="shim" /><div className="shim" />
                                    <Html html={`<div class="tbm_shop_local" data-options=" { 'api_key' : 'iptFYa3Dp9eUlyeboWwqNlUZzkwPaTkO', 'product_code' : '${eisbn}', 'image' : 'https://bookmanager.com/public/api/btns/Shop Local Button.png' }" />`} />

                                    <div><ListQuickPick eisbn={eisbn} my_lists={myLists} updateMyListsInParent={setMyLists} /></div>
                                    <div className="shim" /><div className="shim" />
                                    <Space wrap size={[3, 3]}>
                                        {(session.logged_in && <ListCount title={title} my_lists={myLists} eisbn={eisbn} updateMyListsInParent={setMyLists} />)}
                                        {(catalogue_count > 0 && <CatalogueCount count={catalogue_count} eisbn={eisbn} />)}
                                        {(digital_resources && <DigitalResources data={digital_resources} />)}
                                        <TitleRelated eisbn={eisbn} related_count={related_count} />
                                    </Space>

                                </div>
                            </Col>
                        </Row>



                        {((view === "full" || view === "details") && <div style={{ "width": "100%" }}>

                            {(view === "full" &&
                                <div className="float-flex">
                                    <div></div>
                                    <Space>
                                        {drawPrev()}
                                        {drawNext()}
                                        <Button onClick={history.goBack}>Go back</Button>
                                    </Space>
                                </div>
                            )}

                            <Pubstock eisbn={eisbn} suppliers={pubstock} />
                            <div className="shim" /><div className="shim" />
                            {(peer_sales && <Peers data={peer_sales} />)}
                        </div>)}
                    </div>

                    {((view === "details" || view === "full") && <TitleExtras list_id={list_id} titlelist_id={titlelist_id} view={view} data={data} />)}
                    {(divider && <Divider dashed />)}
                </div>
            </Spin>
        )

    }


    return drawSummary()

}